<template>
	<div>
		<div class="IndexCenterText TowFixed">
			<div class="Text">
				指标中心
			</div>
			<!-- 热力图部分 -->
			<!-- <div class="NsghMap-Center-top" v-show="CanShow">
        <NsghMap :NsghMapData="NsghMapData" :dataListHot="dataListHot.data" :FromArr="NsghMapFrom" @YearChange='YearChange'></NsghMap>
      </div> -->
			<!-- 商业报表 -->
			<div class="BusinessStatement">
				<div class="search">
					<FromComm style="height:24px;" :FromArr="FromArr"></FromComm>
					<CommonBtngroup style="margin-left: 20px;" ref="Btngroup" :qhide="false" @select="handSubmit"
						@reset="handReset">
					</CommonBtngroup>
				</div>
			</div>
			<div class="NsghMap-Center-bottom">
				<div class="left-Echarts NsghMap-Center-bottom-comStyle">
					<div class="top">
						<div class="Echarts-title">
							<EchartsTitle title='本年度采购指标达成率' SeeMoreUrlProp="procurementIndex"></EchartsTitle>
						</div>

						<div style="margin-top: 20px;margin-bottom: 10px;">
							<CommonEchartsCustomGauge :num='1' :valueObject="Quarter"></CommonEchartsCustomGauge>
						</div>
					</div>

					<div class="bottom">
						<div class="Echarts-title">
							<EchartsTitle title='季度采购指标达成&目标金额' SeeMoreUrlProp="procurementIndex"></EchartsTitle>
						</div>
						<CommonEchartsBar :echartsOptions='echartsOptionsDMJ' :QuarterAmount="Quarter">
						</CommonEchartsBar>
					</div>
				</div>
				<div class="center-Echarts NsghMap-Center-bottom-comStyle">
					<div>
						<div class="Echarts-title">
							<EchartsTitle title='本年度销售总量（YTD）' SeeMoreUrlProp="salesIndicators"></EchartsTitle>
						</div>
						<CommonEchartsCircleStyle :value='QuarterAmount'></CommonEchartsCircleStyle>
					</div>
					<div class="bottom bottomCenter">
						<div class="Echarts-title">
							<EchartsTitle title='季度销售额' SeeMoreUrlProp="salesIndicators"></EchartsTitle>
						</div>
						<div style="margin-top: -5px;">
							<CommonEchartsBar :echartsOptions='echartsOptionsJXE' :QuarterAmount='QuarterAmount'>
							</CommonEchartsBar>
						</div>
					</div>
				</div>
				<div class="right-Echarts NsghMap-Center-bottom-comStyle">
					<div class="top">
						<div class="Echarts-title">
							<EchartsTitle title='库存透视参考价格合计'></EchartsTitle>
						</div>
						<CommonEchartsCircleStyle :value='StockCost'></CommonEchartsCircleStyle>
					</div>
					<div class="bottom bottomCenter">
						<div class="Echarts-title">
							<EchartsTitle title='库存分布'></EchartsTitle>
						</div>
						<div style="margin-top: -5px;">
							<CommonEchartsPie :echartsOptions='echartsOptionsKCFB' :StockCost='StockCost'>
							</CommonEchartsPie>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import FromComm from '../../../../components/fromComponents/Commfrom/from-comm.vue'
	import NsghMap from './EcharsComponents/NsghMap/NsghMap.vue'
	import CommonEchartsCustomGauge from '@/components/common-Echarts/common-Echarts-CustomGauge.vue'
	import CommonEchartsCircleStyle from '@/components/common-Echarts/common-Echarts-CircleStyle.vue'
	import CommonEchartsBar from '@/components/common-Echarts/common-Echarts-Bar.vue'
	import CommonEchartsPie from '@/components/common-Echarts/common-Echarts-Pie.vue'
	import EchartsTitle from '@/components/common-Echarts/Echarts-title'
	import CommonBtngroup from '@/components/commongroup.vue'
	import echartsOptionsDMJ from './EcharsComponents/EchartsFormData/echartsOptionsDMJ'
	import echartsOptionsJXE from './EcharsComponents/EchartsFormData/echartsOptionsJXE'
	import echartsOptionsKCFB from './EcharsComponents/EchartsFormData/echartsOptionsKCFB'
	import NsghMapFrom from './EcharsComponents/FormData/NsghMapFrom'
	import {
		HelperOrganization
	} from '@/api/channel'
	import {
		QuotaReportASNReportByL2
	} from '@/api/echartsApi'

	export default {
		components: {
			NsghMap,
			CommonEchartsCustomGauge,
			EchartsTitle,
			CommonEchartsCircleStyle,
			CommonEchartsBar,
			CommonEchartsPie,
			FromComm,
			CommonBtngroup
		},
		props: {
			dataListHot: {
				type: Object,
				default: () => {
					return {}
				}
			},
			QuarterAmount: {
				type: Object,
				default: () => {
					return {

					}
				}
			},
			Quarter: {
				type: Object,
				default: () => {
					return {

					}
				}
			},
			StockCost: {
				type: Object,
				default: () => {
					return {

					}
				}
			},

		},
		data() {
			return {
				NsghMapData: {
					title: '全国销量热力图',
					areaCode: 100000
				},
				echartsOptionsDMJ: [],
				echartsOptionsJXE: [],
				echartsOptionsKCFB: [],
				NsghMapFrom: [],
				OutOrganization: [], //多选选中的数据
				L2data: {},
				FromArr: [{
					modelvalue: '',
					title: "年份：",
					inputtype: "date",
					inputflag: true,
					fontSize: 14,
					color: "#333333",
					X: false,
					types: "year",
					placeholder: "请选择",
					disabled: false,
					displayVal: "inline-block",
				}]
			}
		},
		mounted() {
			this.echartsOptionsDMJ = JSON.parse(JSON.stringify(echartsOptionsDMJ))
			this.echartsOptionsJXE = JSON.parse(JSON.stringify(echartsOptionsJXE))
			this.echartsOptionsKCFB = JSON.parse(JSON.stringify(echartsOptionsKCFB))
			this.NsghMapFrom = JSON.parse(JSON.stringify(NsghMapFrom))
			this.FromArr[0].modelvalue = this.$utils.getDaysIndex().year + '';
		},
		methods: {
			handSubmit() {
				this.$emit('load', {
					Year: this.FromArr[0].modelvalue.substring(0, 4)
				})
			},
			handReset() {
				this.FromArr[0].modelvalue = this.$utils.getDaysIndex().year + '';
				this.$emit('load', {
					Year: this.FromArr[0].modelvalue.substring(0, 4)
				})
			}
		}
	}
</script>

<style lang="less">
	.TowFixed {
		width: 1200px;
		margin: 0 auto;
	}

	.IndexCenterText {
		margin-bottom: 40px;

		// 商业报表
		.BusinessStatement {
			width: 100%;
			height: 100px;
			border-radius: 0px 0px 0px 0px;
			background-color: #fff;
			display: flex;
			justify-content: center;
			margin-top: 20px;

			.search {
				display: flex;
				align-items: center;
			}

			.chars-pie {
				width: 550px;
				height: 100%;
				// outline: 1px solid rgb(34, 219, 9);

				.Top {
					width: 100%;
					// outline: 1px solid red;
					text-align: center;

					span:nth-child(1) {
						font-size: 16px;
						font-weight: 500;
						color: #333333;
						margin-right: 20px;
					}

					span:nth-child(2) {
						font-size: 24px;
						font-weight: 500;
						color: #e71d43;
					}
				}

				.charts {
					width: 100%;
					height: 80%;
					margin-top: 20px;
				}
			}
		}

		.Text {
			text-align: center;
			color: #16181a;
			font-weight: bold;
			font-size: 28px;
		}

		.NsghMap-Center-top {
			width: 100%;
			// height: 520px;
			border-radius: 0px 0px 0px 0px;
			background-color: #fff;
			margin-top: 26px;
		}

		.NsghMap-Center-bottom {
			width: 100%;
			height: 100%;
			border-radius: 0px 0px 0px 0px;
			opacity: 1;
			// background-color: #fff;
			margin-top: 16px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.left-Echarts {}

			.center-Echarts {}

			.right-Echarts {}
		}

		.NsghMap-Center-bottom-comStyle {
			width: 376px;
			height: 750px;
			background: #ffffff;
			border-radius: 8px 8px 8px 8px;
			padding-bottom: 20px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.Echarts-title {
				width: 100%;
				height: 44px;
				// outline: 1px solid red;
				position: relative;
			}

			.top {
				// outline: 1px solid rebeccapurple;
			}

			.bottom {
				// outline: 1px solid rebeccapurple;
			}

			.bottomCenter {
				// outline: 1px solid rebeccapurple;
				height: 420px;
			}
		}
	}
</style>
